import { isDirectoryEntry, isFileEntry } from './fileSystemEntry';
import readDirectoryEntries from './readDirectoryEntries';

// ----------------------------------------------------------------------------

async function dragCountEntry(entry: FileSystemEntry): Promise<number> {
    if (isFileEntry(entry)) {
        return 1;
    }

    if (isDirectoryEntry(entry)) {
        const entries = await readDirectoryEntries(entry);
        const counts = await Promise.all(entries.map(dragCountEntry));

        return counts.reduce((sum, c): any => sum + c, 0);
    }

    return 0;
}

// ----------------------------------------------------------------------------

export default dragCountEntry;
